export const INITIALIZE = "initialize";
export const APPEND_REACTIONS = "appendReactions";
